export default __webpack_public_path__ + "static/media/4-statuses.4358f74a.png";